__turbopack_context__.v({
  "tableRowContainer": "TableRow-module-scss-module__LvwLNa__tableRowContainer",
});
